import { Component, effect, inject, OnInit } from '@angular/core';
import { SidebarService } from '../../../services/menu/sidebar.service';
import { SidebarConfiguration } from '../../../models/sidebar-configuration';
import { MenuItem, MessageService } from 'primeng/api';
import { TabMenuModule } from 'primeng/tabmenu';
import { PanelMenuModule } from 'primeng/panelmenu';
import { RoleStore } from '../../../stores/role/role.state';
import { FormGroup } from '@angular/forms';
import { CommuneStore } from '../../../stores/commune/commune.state';
import { Commune } from '../../../models/commune';
import { GlobalsStore } from '../../../stores/globals.state';

@Component({
  selector: 'app-configuration',
  standalone: true,
  imports: [TabMenuModule, PanelMenuModule],
  templateUrl: './configuration.component.html',
  styleUrl: './configuration.component.scss',
})
export class ConfigurationComponent implements OnInit {
  sidebarConfig: SidebarConfiguration = {
    cssClasses: 'w-12',
    icon: 'fas fa-gears',
    headerText: 'Atlaskonfigurationen',
  };
  readonly globalStore = inject(GlobalsStore);
  form: FormGroup = new FormGroup({});
  initialized = false;
  items: MenuItem[] = [];
  activeCommune: Commune | null = null;

  constructor(private sidebarService: SidebarService) {
    effect(() => {
      if (!this.activeCommune) {
        this.activeCommune = this.globalStore.activeCommune();
      }
    });
  }

  ngOnInit() {
    this.initMenu();
    setTimeout(() => {
      this.sidebarService.setConfiguration(this.sidebarConfig);
    }, 10);
  }

  /**
   * Initializes the menu items with their labels, icons, and routing information.
   *
   * @return {void} This method does not return a value.
   */
  initMenu(): void {
    this.items = [
      {
        label: 'Allgemeines',
        icon: 'fas fa-cog',
        routerLink: [{ outlets: { panel: 'atlas' } }],
      },
      {
        label: 'Startseite',
        icon: 'fas fa-home',
        routerLink: [{ outlets: { panel: 'startseite' } }],
      },
      {
        label: 'Navigation',
        icon: 'fas fa-sitemap',
        routerLink: [{ outlets: { panel: 'navigation' } }],
      },
      {
        label: 'Karten',
        icon: 'fas fa-map',
        routerLink: [{ outlets: { panel: 'karte' } }],
      },
      {
        label: 'Diagramme',
        icon: 'fas fa-bar-chart',
        routerLink: [{ outlets: { panel: 'diagramme' } }],
      },
      {
        label: 'Schlagworte',
        icon: 'fas fa-tags',
        routerLink: [{ outlets: { panel: 'schlagworte' } }],
      },
      {
        label: 'Vergleichswerte',
        icon: 'fas fa-scale-unbalanced-flip',
        routerLink: [{ outlets: { panel: 'vergleichswerte' } }],
      },
      {
        label: 'Gast-Links',
        icon: 'fas fa-link',
        routerLink: [{ outlets: { panel: 'links' } }],
      },
      {
        label: 'Bilder',
        icon: 'fas fa-images',
        routerLink: [{ outlets: { panel: 'bilder' } }],
      },
    ];
  }
}
